export default __webpack_public_path__ + "static/media/Solveig-2018.842b03f0.jpg";